import React, { useState, useEffect, useCallback } from "react";
import { Routes, Route, Link } from "react-router";

import "bootstrap/dist/css/bootstrap.min.css";
//import logo from "./logo_clean_verify.png"
import "./App.css";

import AuthService from "./services/auth.service";

import ProtectedRoute from './components/ProtectedRoute';


import Login from "./components/Login";
import Logout from "./components/Logout";

import Register from "./components/Register";
import Home from "./components/Home";
import MyCompliance from "./components/MyCompliance";
import MyUserX from "./components/MyUserX";
import UxSurvey from "./components/UxSurvey";
import MyTasks from "./components/MyTasks";
import MyCourses from "./components/MyCourses"
import Eval from "./components/Eval";
import UxReport from "./components/UxReport";

import Profile from "./components/Profile";




//import AuthVerify from "./common/AuthVerify";
//import EventBus from "./common/EventBus";

const App = () => {
  //const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  //const [showAdminBoard, setShowAdminBoard] = useState(false);
  
  //
   
  /*
  const logOut = () => {
    AuthService.logout();
    //setShowModeratorBoard(false);
    //setShowAdminBoard(false);
    setCurrentUser(undefined);
  };
  */
  
   const [flashMessage, setFlashMessage] = useState(null);

     // Memorizamos la función para que no cambie la referencia del DOM
  const closeFlash = useCallback(() => {
    setFlashMessage(false);
  }, []);

  return (
    
      
    
      <div id="routes" className="bg-gradient-to-br from-neutral-200 via-white to-neutral-200 min-h-screen  overflow-auto" >
          <Routes>
            <Route path={"/"} element={<Home />} />
            
            
            <Route path={"/login"} element={<Login />} />
            <Route path={"/logout"} element={<Logout />} />
            <Route path={"/register"} element={<Register />} />
            
            <Route element={<ProtectedRoute />}>

              <Route path={"/home"} element={<Home />} />              
              <Route path={"/mycompliance"} element={<MyCompliance />} />
              <Route path={"/myuserx"} element={<MyUserX />} />
              <Route path={"/mytasks"} element={<MyTasks />} />
              <Route path={"/mycourses"} element={<MyCourses />} />
              <Route path={"/profile"} element={<Profile />} />
              <Route path={"/uxreport"} element={<UxReport flashMessage={flashMessage} setFlashMessage={setFlashMessage} closeFlash={closeFlash}/>} />
              <Route path={"/eval"} element={<Eval flashMessage={flashMessage} setFlashMessage={setFlashMessage} closeFlash={closeFlash}/>} />
            </Route>

            <Route path={"/UxSurvey"} element={<UxSurvey />} />

            
            {/*}
            <Route path="/user" element={<BoardUser />} />
            <Route path="/mod" element={<BoardModerator />} />
            <Route path="/admin" element={<BoardAdmin />} />
          */}

          </Routes>
      </div>
       
      
      
      
    
  );
};

export default App;
